module.exports = __webpack_public_path__ + "static/media/wait.f4404720.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/wait.gif
// module id = 974
// module chunks = 0